export const tabsValues = Object.freeze({
    SMART_PREDICT: "SMART_PREDICT",
    PHYSIOLOGY:"PHYSIOLOGY",
    GENERAL_INFORMATION: "GENERAL_INFORMATION",
    OBSERVATION: "OBSERVATION",
    TIPS: "TIPS",
    VDSI: "VDSI",
    EXPERTISE: "EXPERTISE"
})